import { Form, Radio, Select } from '@maxtropy/components';
import FurnaceSelector, { FurnaceItem } from '../FurnaceSelector';
import styles from './index.module.scss';

interface StrategySectionProps {
  type: 'reduce' | 'increase';
  furnaces: FurnaceItem[];
  furnacesLoading?: boolean;
}

const StrategySection = ({ type, furnaces, furnacesLoading }: StrategySectionProps) => {
  const isReduce = type === 'reduce';
  const actionText = isReduce ? '降负荷' : '升负荷';
  const modeName = `${type}Mode`;
  const customMethodName = `${type}CustomMethod`;
  const loadObjectIdsName = `${type}LoadObjectIds`;

  return (
    <section className={styles.section}>
      <Form.Item label={`${actionText}调控模式`} name={modeName} rules={[{ required: true, message: '请选择' }]}>
        <Radio.Group className={styles.modeRadioGroup}>
          <Radio value={1}>
            均衡{isReduce ? '降' : '升'}负载（系统在全体炉台中均衡分配{actionText}）
          </Radio>
          <Radio value={2}>自定义{actionText}（指定炉台/指定优先炉型）</Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item noStyle shouldUpdate={(previous, current) => previous[modeName] !== current[modeName]}>
        {({ getFieldValue }) => {
          if (getFieldValue(modeName) !== 2) return null;

          return (
            <>
              <Form.Item
                label="自定义方式"
                name={customMethodName}
                rules={[{ required: true, message: '请选择自定义方式' }]}
              >
                <Select
                  className={styles.methodSelect}
                  options={[
                    { label: '指定炉台（勾选参与调节的炉台）', value: 1 },
                    { label: '优先电石炉', value: 2 },
                    { label: '优先硅铁炉', value: 3 },
                  ]}
                />
              </Form.Item>

              <Form.Item
                noStyle
                shouldUpdate={(previous, current) => previous[customMethodName] !== current[customMethodName]}
              >
                {({ getFieldValue: getCustomMethod }) =>
                  getCustomMethod(customMethodName) === 1 ? (
                    <Form.Item
                      label="勾选炉台"
                      name={loadObjectIdsName}
                      rules={[{ required: true, type: 'array', min: 1, message: '请至少选择一个炉台' }]}
                    >
                      <FurnaceSelector furnaces={furnaces} loading={furnacesLoading} />
                    </Form.Item>
                  ) : null
                }
              </Form.Item>
            </>
          );
        }}
      </Form.Item>
    </section>
  );
};

export default StrategySection;
